<template>
  <div class="text-center">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />
  </div>
</template>

<script>
import Confirm from "@/components/Confirm";
export default {
  components: { Confirm },
  data() {
    return { cname: "", cpassword: "", Signindialog: true };
  },
 
 async mounted() {
    this.progressBar = true;
    this.myJsonResp = await this.PostData("Signout", "");
    this.progressBar = false;
     if (this.myJsonResp == "ERROR") {
        localStorage.removeItem('IIRToken')
        this.$router.push("/Signin");
      } else {
        localStorage.removeItem('IIRToken')
        await this.$refs.confirm.open(
          "Signed Out",
          "Good bye !",
          "",
          "Close",
          { color: "success" }
        );
        this.$router.push("/Signin");
      }
    },
 
};
</script>